class ProductMediaGrid extends HTMLElement {
  productId = this.dataset.productId;
  sectionId = this.dataset.sectionId;

  connectedCallback() {
    this.unsubscribeVariantChanged = subscribe(
      `variant:changed:${this.productId}:${this.sectionId}`,
      (data) => {
        this.handleVariantChange(data);
      }
    );
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
  }

  handleVariantChange({ html }) {
    const productMediaGrid = html.querySelector('product-media-grid');
    if (productMediaGrid) this.replaceWith(productMediaGrid);
  }
}

customElements.define('product-media-grid', ProductMediaGrid);
